import { render, staticRenderFns } from "./DefaultPasswordRecoveryEmailConfirmation.vue?vue&type=template&id=39e78034&lang=pug&"
import script from "./DefaultPasswordRecoveryEmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DefaultPasswordRecoveryEmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports